import { el, text } from "./utils"
import Top from "./top"
import { IQuestion } from "./models"

export default class Form {
  private fields: Array<IQuestion>
  public element: HTMLFormElement = el('form')
  private answers: Array<String>
  private warned = false
  private top: Top
  constructor(fields: Array<IQuestion>, top: Top){
    this.fields = fields
    this.answers = []
    this.init()
    this.buildform()
    this.top = top
  }
  init(){
    for(let i = 0; i < this.fields.length; i++){
      this.answers.push('')
    }
  }
  flipContent(html: string, stage: number){
    this.element.innerHTML = ''
    const response = el('div', {
      attrs: {
        class: "response"
      }
    })
    response.innerHTML = html
    this.top.message(
      response,
      stage
    )
  }
  validate(){
    let valid = true
    let answered = true
    this.answers.forEach((answer, id) => {
      if(answer === ''){
        answered = false
      } else if(answer === 'yes') {
        valid = false
      }
    })
    return {valid, answered}
  }
  submit(e: Event){
    e.preventDefault()
    const validation = this.validate()
    if(!validation.answered) {
      this.warn()
    } else {
      if(validation.valid){
        this.flipContent(window.PASSED_CONTENT, 3)
      } else {
        this.flipContent(window.FAILED_CONTENT, 2)
      }
    }
  }
  warn(){
    if(!this.warned){
      this.warned = true
    }
    this.render()
  }
  changeField(e: InputEvent){
    const target = e.target as HTMLInputElement
    if(target){
      this.answers[parseInt(target.name)] = target.value
    }
  }
  createRadio(name: string, value: string, label?: string, checked?: boolean){
    const input = el('input', {
      attrs: {
        type: 'radio',
        name,
        value,
        checked
      }
    })
    input.addEventListener('change', (e) => this.changeField(e as InputEvent))
    if (label){
      return el('label', {
        attrs: {
          'class': 'is-button'
        },
        children: [
          input,
          el('span', {
            content: label
          })
        ]
      })
    } else {
      return input
    }
  }
  createFieldElements(){
    return el('fieldset', {
      children: [
/*         el('h3', {
          content: 'Have you or anyone in your home had any of these symptoms in the past 72 hours?'
        }), */
        ...this.fields.map((field, id) => {
          return el('div', {
            attrs: {
              'class': `field ${(this.warned && this.answers[id] === '') ? 'error' : ''}`
            },
            children: [
              el('h4', {
                content: field.title
              }),
              el('div', {
                content: field.description
              }),
              this.createRadio(`${id}`, 'yes', 'Yes', this.answers[id]=== 'yes'),
              this.createRadio(`${id}`, 'no', 'No', this.answers[id]=== 'no')
            ]
          })
        }),
        el('button', {
          attrs: {
            type: 'submit',
            class: 'button',
            style: 'margin-top: 15px'
          },
          content: 'Submit'
        }),
        (this.warned) ? el('span', {
          attrs: {
            class: 'form-msg error'
          },
          content: 'You must select Yes or No for each question'
        }): null
      ]
    })
  }
  render(){
    this.element.innerHTML = ''
    this.element.appendChild(this.createFieldElements())
  }
  buildform(){
    this.element.addEventListener('submit', (e) => this.submit(e))
    this.render()
  }
  public show(){
    this.element.style.display='block'
  }
}